import * as fr from '../../../../../../config/locales/js/fr.json';
angular.module('cerego.translate').constant('translateFr', fr);
